const state = {
  isIndex: '',
  roleData: ''
}

const mutations = {
  openDataFunc(state, payload) {
    state.roleData = payload;
  },
  changeInd(state, payload) {
    state.isIndex = payload;
  }
}

const actions = {
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js